console.log("input-quantity-controller.js loaded");

document.addEventListener('on:cart:add', validateInputQuantity);

function validateInputQuantity(event) {
        console.log('Item added to cart:', event.detail);
        const variantId = event.detail.variantId;
        console.log('Variant ID:', variantId);
        const currentVariantId = document.querySelector('[name="id"]').value;
        if (currentVariantId != variantId) {
            return;
        } 
        const quantityInput = document.querySelector('input[name="quantity"]');
        const stepValue = quantityInput.getAttribute('step');
        quantityInput.value = stepValue;
        quantityInput.min = stepValue;
        
}
